import { DeleteBookingModal } from "PFApp/booking/components/delete_booking_modal/delete_booking_modal";
import { useDeleteBookingModal } from "PFApp/booking/components/delete_booking_modal/use_delete_booking_modal";
import { ActionIcon } from "PFComponents/action_icon";
import { getProfileName } from "PFCore/helpers/profile";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { Booking } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./action_column.module.scss";

type ActionColumnProps = {
  booking: Booking;
  readOnly: boolean;
  onEdit?: (booking: Booking) => void;
  onDelete?: VoidFunction;
};
export const ActionColumn = ({ booking, readOnly, onEdit, onDelete }: ActionColumnProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "show.parts.availability" });
  const { data: currentProfile } = useCurrentProfile();

  const { getCategory } = useBookingCategories();
  const category = getCategory(booking);

  const modal = useDeleteBookingModal();
  const {
    state: { isOpen, data }
  } = modal;
  const isDeleteModalOpen = isOpen && !!data;

  const isReadOnly = readOnly || booking.readonly || booking.source !== "ui";

  return (
    <div className={css.root}>
      {!isReadOnly && !!category && (
        <>
          <ActionIcon
            title={t("editBooking")}
            name="edit"
            size="sm"
            onClick={(event) => {
              event.stopPropagation();
              onEdit?.(booking);
            }}
          />
          <ActionIcon
            title={t("deleteBooking")}
            name="remove"
            size="sm"
            onClick={(event) => {
              event.stopPropagation();
              modal.open({
                bookingId: booking.id,
                profileFullName: getProfileName(currentProfile),
                onDeleted: () => {
                  onDelete?.();
                  return Promise.resolve();
                }
              });
            }}
          />
          {isDeleteModalOpen && <DeleteBookingModal {...data} onClose={modal.close} />}
        </>
      )}
    </div>
  );
};
